import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "trello",
  "name": "Trello",
  "category": "integrations",
  "description": "Create and manage Trello boards and cards",
  "icon": "siTrello",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.4.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Trello",
    "color": "#0079bf"
  },
  "credentials": [
    {
      "name": "trelloApi",
      "required": true,
      "displayName": "Trello API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "trello",
    "boards",
    "cards",
    "project-management",
    "kanban"
  ],
  "comingSoon": true
};

export default definition;
